import React from "react";

import ItemCourse from "@components/item-course/item-course";

import { ICourse } from "@typings/global.types";

type PropsType = {
  course: ICourse;
  className?: string;
};

function WrapperItemCourse({ course, className }: PropsType) {
  return (
    <ItemCourse
      className={className}
      courseName={course.layoutName}
      valueInProgress={course.currentExerciseNumber ?? 0}
      progress={(course.completedExercisesCount / course.exercisesCount) * 100}
      completedLessonsCount={course.completedLessonsCount}
      lessonsCount={course.lessonsCount}
      exercisesCount={course.exercisesCount}
      completedExercisesCount={course.completedExercisesCount}
    />
  );
}

export default WrapperItemCourse;
